module.exports = __webpack_public_path__ + "img/grid.0ed55763.svg";